export const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16),
          }
        : null;
};

export const rgba = (hex, alpha) => {
    const colorRgb = hexToRgb(hex);
    return colorRgb ? `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${alpha})` : null;
};
